var swiper = new Swiper(".block_featured-blog-slider", {
    slidesPerView: 4,
    spaceBetween: 10,
    pagination: {
      el: ".block_featured-blog-slider .swiper-pagination",
      clickable: true,
    },
   navigation: {
        nextEl: ".block_featured-blog .block_slider-right-arrow",
        prevEl: ".block_featured-blog .block_slider-left-arrow",
    },
    mousewheel: {
      forceToAxis: true,
  },
    breakpoints: {     
      280: {
        slidesPerView: 1.2,
        spaceBetween: 10
      }, 
      500: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      749: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      989: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });